// @mui
import { styled } from '@mui/material/styles';
import { Container, Box } from '@mui/material';
// components
import sidebarlogo from '../../src/components/logo/sidebarlogo/imagesidebar.png';
// sections
import { LoginForm } from '../sections/auth/login';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function LoginPage() {
  return (
    <>
      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <Box>
              <img
                style={{ paddingInline: 0, width: '50%', height: '50%', margin: 'auto', marginBottom: '50px' }}
                src={sidebarlogo}
                alt=""
              />
            </Box>
            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
